import { AdminAsyncActions } from 'store/actions/admin';
import { createReducerFromActions } from 'utils/store';
import { values } from 'lodash';

export default createReducerFromActions(...values(AdminAsyncActions));
